import { Formatter } from "@leapwallet/leap-evm-js";
import { Button, Group, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useLeapSdk } from "../../context/sdk";
import BigSquare from "../puzzle/BigSquare";

export default function Home() {
  const { user, loading, leapSdk, wallet } = useLeapSdk();
  const [playing, setPlaying] = useState(false);
  const sendTransaction = async () => {
    const txApi = leapSdk.getTxApiProvider(wallet);
    const nativeTx = await txApi.createNativeTx({
      from: wallet.address,
      to: "0x4c2Bb0d8Fa4f24aA7f485141663C1ad56aeC78D7",
      amount: Formatter.SmallToBig("0.1", 18),
    });
    await txApi.signAndBroadcastTx(nativeTx);
  };
  const handlePlay = () => {
    setPlaying(true);
  };
  const renderData = () => {
    let content = null;
    if (loading) {
      content = <h2>Loading...</h2>;
    } else if (user) {
      if (playing) {
        content = (
          <>
            <Group position="right" align="center" sx={{ width: "100%" }}>
              <TimeLeft leapSdk={leapSdk} sendTransaction={sendTransaction} />
            </Group>
            <BigSquare />
          </>
        );
      } else
        content = (
          <>
            <h2>You are almost done</h2>
            <Button
              sx={{
                width: "fit-content",
                backgroundColor: "rgb(35,35,35)",
                borderRadius: "16px",
              }}
              onClick={handlePlay}
            >
              Click here to play
            </Button>
          </>
        );
    } else {
      content = (
        <>
          <h2>Play to Earn Game</h2>
          <img src="/sample.png" alt="sample game" width="512" height="484" />
        </>
      );
    }
    return content;
  };
  return (
    <div className="app-container">
      <div className="app-container_data">{renderData()}</div>
    </div>
  );
}

const TimeLeft = ({ sendTransaction }) => {
  const [timer, setTimer] = useState(30);
  useEffect(() => {
    const timerId = setInterval(() => {
      setTimer((t) => {
        if (t === 0) {
          sendTransaction();
          clearInterval(timerId);
          return t;
        }
        return t - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  return (
    <Group spacing={4}>
      <Text size="14px" weight="bold">
        Time Left :
      </Text>
      <Text
        size="14px"
        weight="bold"
        sx={{ color: timer < 10 && timer !== 0 ? "red" : "white" }}
      >
        {`0${timer}`.slice(-2)}
      </Text>
    </Group>
  );
};
